module.exports = __webpack_public_path__ + "img/s-hd.0a8cee8b.jpg";